import Pagination from "./../../../../components/share/pagination";
import Service from "../../../../utils/api/service";
import Helper from "../../../../utils/global/func";
import TableLoading from "./../../../../components/share/table-loading";
import NoItem from "./../../../../components/share/table-no-item";
import { mapState } from "vuex";

export default {
  name: "ListCurrency",
  data() {
    return {
      isFetching: true,
      isNoData: false,
      data: {
        currencies: [],
      },
      search: {
        status: "",
      },
      display: {
        modal: {
          delete: {
            index: -1,
            show: false,
          },
          large: false,
        },
      },
      field: {
        index: "",
      },
      isDeleting: false,
      detail: {},
    };
  },
  components: {
    Pagination,
    TableLoading,
    NoItem,
  },
  created() {
    this.setParams();
    this.getAllCurrency(10, 0);
  },
  mounted() {},
  watch: {
    "$route.fullPath": function () {
      this.setParams();
      this.getAllCurrency();
    },
  },
  computed: {
    ...mapState(["permissions"]),
  },
  methods: {
    setParams() {
      this.search = this.$helper.setParams(
        this.search,
        this.$root.$route.query
      );
    },

    checkoutPermission(permissionName) {
      if (this.permissions) {
        let result = false;
        this.permissions.find((item) => {
          item.permissions.find((permission) => {
            if (permission.name == permissionName) {
              result = true;
            }
          });
        });

        return result;
      }
    },

    getFullImage(path) {
      return Helper.getFullImage(path);
    },

    getAllCurrency(limit, offset) {
      this.isFetching = true;
      let query = this.$root.$route.query;
      let setQuery = this.$helper.filterKeyMapping({
        page: query?.page || 1,
        ...query,
      });
      let params = this.$helper.queryParam(setQuery);

      Service.getAllCurrency(params).then((response) => {
        this.isFetching = false;
        if (response?.statusCode) {
          this.$toasted.show(response?.message);
          if (response.statusCode === "4410") {
            Service.refreshToken().then((response) => {
              if (response === "ok") {
                this.getAllCurrency(limit, offset);
              }
            });
          } else if (response?.statusCode === "403") {
            this.isNoData = true;
          } else {
            this.$toasted.show(response?.message);
          }
        } else {
          if (response?.data.length > 0) {
            this.data.currencies = response?.data;
            this.isNoData = false;
          } else {
            this.data.currencies = [];
            this.isNoData = true;
          }
        }
      });
    },

    async searchStatus() {
      let query = this.$helper.filterKeyMapping({
        limit: 10,
        page: 1,
        ...this.search,
      });
      await this.$router.push({ query }).catch(() => {});
    },

    popupModalDelete(index) {
      this.display.modal.delete.index = index;
      this.display.modal.delete.show = true;
    },

    closeModal() {
      this.display = {
        modal: {
          delete: {
            index: -1,
            show: false,
          },
          large: false,
        },
      };
    },

    modalDetail() {
      this.display.modal.detail = true;
    },

    deleteCurrency() {
      this.isDeleting = true;
      let index = this.display.modal.delete.index;
      let param = this.data.currencies[index].code;

      Service.deleteCurrency(param).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.deleteCurrency();
              }
            });
          } else {
            this.isDeleting = false;
            this.$toasted.show(response.message);
          }
        } else {
          this.data.currencies.splice(index, 1);
          this.$toasted.show("Currency has been deleted.");
          this.isDeleting = false;
          this.closeModal();
        }
      });
    },

    updated(value) {
      this.data.currencies[this.field.index] = value;
    },
  },
};
